import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import { BankStatements3MonthRuleset } from '../../business/ruleset';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';

const {
  formField: {
    loanCategory,
    documents: { bankStatement3Month },
  },
} = loanFormModel;

export class BankStatements3MonthValidation implements ValidationSchema {
  public name: string = bankStatement3Month.name;
  public label: string = bankStatement3Month.label;
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = BankStatements3MonthRuleset;

  public when(schema: any, context: any, rulesetResult: RulesetResult) {
    const required = !!(rulesetResult & RulesetResult.REQUIRED);
    const fileSchema = FileNameValidationSchema(
      bankStatement3Month.name,
      required
    );
    if (required) {
      return fileSchema.required('This document is required');
    }
    return fileSchema;
  }
}

export default new Validation(new BankStatements3MonthValidation());
